import useGet from "../useGet";

const useSearchAdministration = (searchText: string) => {
  const companies = useGet(
    `/api/Companies`,
    "Unable to search for company with: '" + searchText + "'",
    [],
    [searchText],
    {
      params: {
        matches: searchText,
        ts: new Date().getTime()
      }
    },
    () => !!searchText && searchText.length >= 4
  );

  const branches = useGet(
    `/api/Branches`,
    "Unable to search for branch with: '" + searchText + "'",
    [],
    [searchText],
    {
      params: {
        matches: searchText,
        ts: new Date().getTime()
      }
    },
    () => !!searchText && searchText.length >= 4
  );

  const users = useGet(
    `/api/Users`,
    "Unable to search for users with: '" + searchText + "'",
    [],
    [searchText],
    {
      params: {
        matches: searchText,
        ts: new Date().getTime()
      }
    },
    () => !!searchText && searchText.length >= 4
  );

  let results: any[] = [];

  if (!!searchText && searchText.length < 4) {
    return results;
  }

  results = users.value.reduce((userResults: any[], user: any) => {
    return userResults.concat(
      user.branches.map((b: any) => ({
        branchName: b.name,
        companyName: user.company.name,
        userName: user.firstName + " " + user.lastName,
        userResult: true,
        companyId: user.company.id,
        branchId: b.id,
        userId: user.id
      }))
    );
  }, []);

  results = results.concat(
    branches.value.map((result: any) => ({
      branch: result,
      branchName: result.name,
      companyName: result.company.name,
      userName: "",
      branchResult: true,
      companyId: result.company.id,
      branchId: result.id
    }))
  );

  results = results.concat(
    companies.value.map((result: any) => ({
      branchName: "",
      companyName: result.name,
      userName: "",
      companyResult: true,
      companyId: result.id
    }))
  );

  return results;
};

export default useSearchAdministration;
